<template>
    <div :class="{showSubMenu:showMobileSubMenu}" class="mainMenu" id="mainMenu" v-bind:style="{height: menuHeight + 'px'}" v-touch:swipe.right="closeMenus" v-on:click="closeOnWhitespace">

        <div>
            <MenuList :key="index" :menuKey="buildKey(section)" :menuList="section" v-for="(section,index) in contentData" v-on:CloseAllMenus="closeMenus" v-on:clearActiveKey="clearActiveKey" v-on:toggleSubMenu="toggleSubMenu"/>
        </div>
    </div>
</template>

<script>
    import OnAnyClick from '../../utils/OnAnyClick.js';
    import OnResize from '../../utils/OnResize.js';
    import MenuList from './MenuList.vue';

    export default {
    components: { MenuList },
    props: {
      contentData: {
        type: Array,
        default: () => [],
      },
      menuState: {
        type: Object,
        default: () => {
        },
      },
    },
    data: function () {
      return {
        menuHeight: 10000,
      };
    },
    computed: {
      showMobileSubMenu() {
        return this.menuState.showMobileSubMenu;
      },
      activeMenuKey() {
        return this.menuState.activeMenuKey;
      },
      showMenu() {
        return this.menuState.showMobileMenu;
      },
    },
    methods: {
      buildKey(section) {
        return 'h-' + section.title.replace(/[\W_]+/g, '');
      },
      closeMenus(payload) {
        if (typeof payload !== 'undefined' && typeof payload.selectedMenuKey !== 'undefined') {
          this.$emit('updateMenuState', { setActiveMenuKey: payload.selectedMenuKey });
        } else {
          this.$emit('updateMenuState', { setActiveMenuKey: '' });
          this.$emit('updateMenuState', { setShowMobileMenu: false, setShowMobileSubMenu: false });
          this.$el.scrollTop = 0;
        }

      },
      closeOnWhitespace(payload) {
        let isWhitespace = true;
        for (let nodecount = 0; nodecount < payload.path.length; nodecount++) {
          if(payload.path[nodecount].classList && payload.path[nodecount].classList.contains('menuList')){
            isWhitespace = false;
            break;
          }
        } 
        if(isWhitespace){this.closeMenus();}
      },
      toggleSubMenu(payload) {
        this.$emit('updateMenuState', { setShowMobileSubMenu: !this.showMobileSubMenu });
        this.$emit('updateMenuState', { setActiveMenuKey: '' });
      },
      clearActiveKey() {
        this.$emit('updateMenuState', { setActiveMenuKey: '' });
      },
    },
    mounted() {
      const self = this;
      OnAnyClick.closeIfNoMatch(this, function (payload) {
        if (!payload[0].classList.contains('miniHeaderMenuIcon') && !payload[0].tagName.toLowerCase() === 'a') {
          self.$emit('updateMenuState', { setShowMobileMenu: false });
        }
        self.$emit('updateMenuState', { setActiveMenuKey: '' });
      });
      OnResize.init(this);
      this.$on('resize', function (payload) {
        this.menuHeight = payload.height || this.menuHeight;
      });
      this.menuHeight = document.documentElement.clientHeight;
    },

  };
</script>

<style>
    .showMobileMenu .mainMenu {
        overflow: hidden;
        -moz-transition: none !important;
    }

    .showMobileMenu .mainMenu.showSubMenu {
        overflow-x: hidden;
        overflow-y: auto;
    }

    .menuSubHeading a {
        padding: 0px;
        color: inherit;
        margin-left: -5px;
    }

    .showMobileMenu .showSubMenu .menuList.open {
        margin-bottom: auto;
    }
</style>
